module.exports = __webpack_public_path__ + "img/qrcode.e5a34438.png";